/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DevicePhoneRefreshIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Device Phone Refresh',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.4 24.452a8.883 8.883 0 0 1 15.5-3.091l1.25-1.25a.491.491 0 0 1 .35-.148.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5.489.489 0 0 1 .147-.35l1.74-1.74a6.056 6.056 0 0 0-10.6 1.436.976.976 0 0 1-.921.62h-1.248a.76.76 0 0 1-.718-.977ZM35.6 29.511A8.883 8.883 0 0 1 20.1 32.6l-1.25 1.251a.494.494 0 0 1-.35.149.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5.49.49 0 0 1-.147.35l-1.74 1.739a6.056 6.056 0 0 0 10.6-1.436.977.977 0 0 1 .921-.62h1.251a.76.76 0 0 1 .715.978Z"
    />
    <path
      d="M16 30H8V6h16v9.347a11.4 11.4 0 0 1 2-.416V2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h8ZM15 2h2a1.04 1.04 0 0 1 1 1 1.04 1.04 0 0 1-1 1h-2a1.024 1.024 0 0 1-1-1 1.024 1.024 0 0 1 1-1Z"
    />
  </svg>`;
};
